import { Pipe, PipeTransform } from '@angular/core';
import { EntityIdFormatterService } from './entity-id-formatter.service';

// take a number #### and a prefix XX ==> XX-00-000#-###
@Pipe({
  name: 'entityFormatter',
})
export class EntityFormatterPipe implements PipeTransform {
  constructor(private entityIdFormatter: EntityIdFormatterService) {}

  transform(value: any, prefix: string): string {
    return this.entityIdFormatter.getFormattedId(value, prefix);
  }
}
